import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { AlertControlFacade, FeedbackViewerFacade } from '@medsurf/flat-facades';
import { FeedbackControlService } from '@medsurf/flat-services';
import { FormControl, FormGroup } from '@angular/forms';
import { ZodSharedValidator } from '@medsurf/flat-validators';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'medsurf-feedback',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent {

  isSubmitting = signal(false);

  feedbackForm = new FormGroup({
    name: new FormControl(''),
    email: new FormControl(''),
    message: new FormControl(''),
  }, {
    validators: ZodSharedValidator.validate(
      FlatModels.FeedbackViewerModels.FeedbackModelSchema.omit({ location: true })
    )
  })

  public constructor(public feedbackViewerFacade: FeedbackViewerFacade,
                    private feedbackControlService: FeedbackControlService,
                    private alertControlFacade: AlertControlFacade) {
  }

  public get showFeedbackModal(): boolean {
    return this.feedbackControlService.showFeedbackModal;
  }

  public close(): void {
    this.feedbackControlService.closeFeedbackModal();
  }

  public async onSubmit() {
    if (this.feedbackForm.invalid || this.isSubmitting()) return;

    this.isSubmitting.set(true);
    const location = this.feedbackControlService.CurrentUrlSegments.join('/');

    const data = {
      ...this.feedbackForm.value,
      location
    }

    try {
      await lastValueFrom(this.feedbackViewerFacade.requestSendFeedback(data));
      this.feedbackForm.reset();
      this.alertControlFacade.requestAddAlert({
        key: 'main',
        detail: 'notification.feedback_saved',
        severity: FlatModels.AlertControlModels.AlertType.enum.success,
        life: FlatModels.AlertControlModels.AlertTime.DEFAULT
      });
      this.close();
    } catch (e) {
      console.log(e?.error);
    } finally {
      this.isSubmitting.set(false);
    }
  }
}
